import { NgModule} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PartnerAccountComponent } from './partner-account/partner-account.component';
import { PartnerCandidateComponent } from './partner-candidate/partner-candidate.component';
import { PartnerContactComponent } from './partner-contact/partner-contact.component';
import { PartnerCredentialingComponent } from './partner-credentialing/partner-credentialing.component';
import { PartnerEmailComponent } from './partner-email/partner-email.component';
import { PartnerInviteComponent } from './partner-invite/partner-invite.component';
import { PartnerOnlineComponent } from './partner-online/partner-online.component';
import { PartnerPackageComponent } from './partner-package/partner-package.component';
import { PartnerPaymentComponent } from './partner-payment/partner-payment.component';
import { PartnerStartComponent } from './partner-start/partner-start.component';
import { PartnerComponent } from './partner.component';

const routes: Routes = [
  {
    path: '', component: PartnerComponent,
    children: [
      { path: 'start', component: PartnerStartComponent},
      { path: 'package', component: PartnerPackageComponent },
      { path: 'candidate', component: PartnerCandidateComponent },
      { path: 'account', component: PartnerAccountComponent },
      { path: 'payment', component: PartnerPaymentComponent },
      { path: 'invite', component: PartnerInviteComponent },
      { path: 'online', component: PartnerOnlineComponent },
      { path: 'credentialing', component: PartnerCredentialingComponent },
      { path: 'contact', component: PartnerContactComponent},
      { path: 'start/:token', component: PartnerStartComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class PartnerRoutingModule { }